import React, { useState } from 'react';

const Logo = ({ size = 'default', variant = 'dark' }) => {
  const [imageError, setImageError] = useState(false);
  const [currentPathIndex, setCurrentPathIndex] = useState(0);

  const sizeClasses = {
    small: {
      height: 'h-12 sm:h-14 md:h-18',
      maxHeight: 'max-h-12 sm:max-h-14 md:max-h-18 lg:max-h-20'
    },
    default: {
      height: 'h-20 md:h-28',
      maxHeight: 'max-h-28 md:max-h-32'
    },
    large: {
      height: 'h-32 md:h-48',
      maxHeight: 'max-h-48 md:max-h-56'
    }
  };

  const currentSize = sizeClasses[size] || sizeClasses.default;

  // Logo image paths - tries multiple locations
  // Primary logo: /images/logo.png
  const logoImagePaths = [
    '/images/logo.png',
    '/images/logo.PNG',
    '/images/wovn-rugs-logo.png',
    '/images/wovn-rugs-logo.jpg',
    '/images/wovn-rugs-logo.jpeg',
    '/images/wovn-rugs-logo.svg',
    '/images/logo.jpg',
    '/images/logo.svg',
    '/logo512.png',
    '/logo192.png',
    '/wovn-rugs-logo.png',
    '/logo.png'
  ];

  const textColor = variant === 'light' ? 'text-white' : 'text-black';

  // Alignment based on size and context
  const getAlignment = () => {
    if (size === 'small') return 'items-center justify-start';
    if (size === 'large') return 'items-center justify-center';
    return 'items-center justify-center';
  };
  
  if (!imageError && currentPathIndex < logoImagePaths.length) {
    return (
      <div className={`flex ${getAlignment()} w-full max-w-full overflow-hidden`}>
        <img 
          src={logoImagePaths[currentPathIndex]} 
          alt="Wovn Rugss Logo – wovnrugss.com" 
          className={`${currentSize.height} ${currentSize.maxHeight} object-contain w-auto max-w-full`}
          style={{ 
            maxWidth: size === 'small' ? '120px' : '100%', 
            width: 'auto',
            height: 'auto', 
            display: 'block',
            objectFit: 'contain'
          }}
          onError={() => {
            // Try next path
            if (currentPathIndex < logoImagePaths.length - 1) {
              setCurrentPathIndex(currentPathIndex + 1);
            } else {
              // All paths failed, show text fallback
              setImageError(true);
            }
          }}
        />
      </div>
    );
  }

  // Fallback text logo if image not found
  const isHeader = size === 'small';
  const alignment = isHeader ? 'items-start' : 'items-center';
  return (
    <div className={`flex flex-col ${alignment} ${textColor}`}>
      <div className={`${isHeader ? 'text-2xl md:text-3xl' : size === 'large' ? 'text-6xl md:text-7xl' : 'text-5xl md:text-6xl'} font-serif font-bold leading-tight ${isHeader ? 'mb-1' : 'mb-2'} relative`} style={{ fontFamily: 'Georgia, serif', lineHeight: '1' }}>
        <span className="relative inline-flex items-baseline whitespace-nowrap">
          <span className="inline-block">W</span>
          <span className="inline-block relative" style={{ marginLeft: isHeader ? '-0.35em' : '-0.4em', zIndex: 1 }}>R</span>
        </span>
      </div>
      <div className={`${isHeader ? 'text-[10px] md:text-xs' : size === 'large' ? 'text-base md:text-lg' : 'text-sm md:text-base'} font-sans ${isHeader ? 'mb-0.5' : 'mb-1'} uppercase whitespace-nowrap`} style={{ letterSpacing: isHeader ? '0.08em' : '0.15em' }}>
        Wovn Rugss
      </div>
      {!isHeader && (
        <div className={`${size === 'large' ? 'text-sm md:text-base' : 'text-xs md:text-sm'} font-serif font-bold whitespace-nowrap`} style={{ fontFamily: 'Georgia, serif' }}>
          LUXURY & PREMIUM RUGS
        </div>
      )}
    </div>
  );
};

export default Logo;

